import InfoClinique from '@/views/parametres/configs/info-clinique'
import ParamPersonnel from '@/views/parametres/configs/param-personnels'
import ParamConsultation from '@/views/parametres/configs/param-consultations'
import ParamExamen from '@/views/parametres/configs/param-examens'
import ParamBon from '@/views/parametres/configs/param-bon-consultations'
import ParamChirurgie from '@/views/parametres/configs/param-chirurgies'
import BilanSante from '@/views/parametres/configs/param-bilan-sante'
import ParamSFE from '@/views/parametres/configs/param-sfe'
import $ from 'jquery'

export default {
    name: 'configs',
    components: {
        InfoClinique, ParamPersonnel, ParamConsultation, 
        ParamExamen, ParamBon, ParamChirurgie, BilanSante,
        ParamSFE
    },
    props: [],
    data() {
        return {
            config_to_show: 2,

            tarif_filter: [
				{
                    libelle: 'Tous',
                    id: '0',
                },
                {
                    libelle: 'Consultations',
                    id: '1',
                },
                {
                    libelle: 'Analyses',
                    id: '2',
                },
				{
                    libelle: 'Examens',
                    id: '3',
                }
            ],
            filtre_tarif: '',
        }
    },

    computed: {

    },

    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);
    },

    methods: {
        changeTab(tabindex) {
            this.config_to_show = tabindex
        },

        onFilterTarif() {
			let id_selected = this.filtre_tarif.id

			if (id_selected > 0) {
				for(let i = 1; i <= 6; i++) {
					if (i != id_selected ) {
						$('.prestation-'+i).fadeOut(500)
					}
				}
				setTimeout(() => {
					$('.prestation-'+id_selected ).fadeIn(500)
				}, 500);
			} else {
				for(let i = 1; i <= 6; i++) {
					$('.prestation-'+i).fadeIn(500)
				}
			}
			
		},
    }
}


